import queryString from 'query-string';
import { closest } from '@utils/domUtils';

export default class ConversationMessages {
  static selectorString() {
    return '.ConversationMessages';
  }

  constructor() {
    this.throttledScrollMessages = this.throttledScrollMessages.bind(this);
    this.userScrolled = this.userScrolled.bind(this);
    this.scrollMessages = this.scrollMessages.bind(this);
  }

  render(node, props) {
    this.scrollableNode = closest(node, '.scroll');
    this.preventAutoScroll = false;

    const query = queryString.parseUrl(window.location.href).query;

    if (query.scroll === 'messages') {
      // NOTE: could do something specific but generally just scrolling down always
    }

    this.throttledScrollMessages();
    window.addEventListener('load', this.throttledScrollMessages);
    this.scrollableNode.addEventListener('scroll', this.userScrolled);

    this.bindTabEvent();
  }

  getTabTrigger() {
    const tab = closest(this.node, '.tab-pane');

    if (!tab) {
      return;
    }

    const tabId = tab.getAttribute('id');
    return document.querySelector(`[data-toggle="tab"][href="#${tabId}"]`);
  }

  bindTabEvent() {
    const tabTrigger = this.getTabTrigger();
    if (tabTrigger) {
      tabTrigger.addEventListener('click', this.throttledScrollMessages);
    }
  }

  unbindTabEvent() {
    const tabTrigger = this.getTabTrigger();
    if (tabTrigger) {
      tabTrigger.removeEventListener('click', this.throttledScrollMessages);
    }
  }

  throttledScrollMessages() {
    this.scrollMessages();
    setTimeout(this.scrollMessages, 170);
    setTimeout(this.scrollMessages, 340);
  }

  scrollMessages() {
    if (this.preventAutoScroll) {
      return;
    }

    if (this.scrollableNode) {
      try {
        this.scrollableNode.scrollTop = Number.MAX_SAFE_INTEGER;
      } catch (err1) {}

      try {
        this.scrollableNode.scroll({ left: 0, top: Number.MAX_SAFE_INTEGER });
      } catch (err2) {}
    }
  }

  userScrolled() {
    this.preventAutoScroll = true;
    this.unbindTabEvent();
    this.scrollableNode.removeEventListener('scroll', this.userScrolled);
    window.removeEventListener('load', this.throttledScrollMessages);
  }
}
